import { Link } from 'react-router-dom';

const FooterItemWrapper = ({ footerItem, children, showWallet }) => {
  if (!footerItem.toPage) {
    return (
      <div
        className={`component-footer-nav-item ${
          footerItem.condition ? 'component-footer-nav-item-selected' : ''
        }`}
        onClick={footerItem.onClick}>
        {children}
      </div>
    );
  }

  return (
    <Link
      className={`component-footer-nav-item ${
        footerItem.condition && !showWallet ? 'component-footer-nav-item-selected' : ''
      }`}
      to={footerItem.toPage}>
      {children}
    </Link>
  );
};

export default FooterItemWrapper;
